import Cookies from "js-cookie";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getExpirationDate, isExpired } from "./checkExpiredToken";
import { SUPPORTED_LANGUAGES } from "./consts";
import getLanguageFromUrl from "./getLanguageFromUrl";

export const useAuthenticationGuard = () => {
  const location = useLocation();

  useEffect(() => {
    const token = Cookies.get("token");

    if (!token) {
      return;
    }

    const expToken = isExpired(getExpirationDate(token));

    if (expToken) {
      Cookies.remove("token");

      window.location.href = `${SUPPORTED_LANGUAGES[getLanguageFromUrl()].url}/login`;
    }
  }, [location.pathname]);
};